import { trace } from '@wk/wk-gatherer';
import { useTranslation } from 'next-i18next';

import { updateVersionState } from '@/api/common';
import { getAccountInfo } from '@/api/home';
import NewModal from '@/components/NewModal';
import useUser from '@/store/useUser';
import { switchVersion } from '@/utils/url';

export default function SwitchVersionModal({
  visible,
  setVisible,
}: {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}) {
  const { t } = useTranslation(['common']);
  const { setAccount } = useUser(store => ({
    setAccount: store.updateAccount,
  }));

  const handleBackOldVersion = async () => {
    await updateVersionState({
      events: [
        { type: 'WEB_HOMEPAGE_NOTICE' },
        { type: 'WEB_VERSION_CHOICE', choice: 'OLD' },
      ],
    });
    const account = await getAccountInfo();
    setAccount(account);
    setVisible(false);
  };

  const handleToNewVersion = async () => {
    trace('C_VersionChange', {});
    await updateVersionState({
      events: [
        { type: 'WEB_HOMEPAGE_NOTICE' },
        { type: 'WEB_VERSION_CHOICE', choice: 'NEW' },
      ],
    });
    switchVersion();
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <NewModal
      customTitle={<div />}
      visible={visible}
      modalStyle={{ borderRadius: '12px', width: '468px', overflow: 'hidden' }}
      contentStyle={{ padding: 0 }}>
      <header className="relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="468"
          height="196"
          fill="none">
          <g clip-path="url(#a)">
            <path fill="#DEECFF" d="M0 .5h468v195H0z" />
            <path
              fill="#D6E8FF"
              d="m-171.349 112.687 5.201-8.541zm44.744-21.987-8.854 4.648-.178-.338-.151-.351zm549.03-60.123-1.04 9.946zM-387 135.05l-6.098-7.926c19.616-15.093 54.038-34.075 94.51-42.782 40.616-8.738 88.021-7.243 132.44 19.804l-5.201 8.541-5.201 8.541c-38.907-23.69-80.746-25.312-117.832-17.333-37.232 8.01-68.972 25.578-86.52 39.08zm215.651-22.363 5.201-8.541c26.261 15.99 45.662 29.167 59.027 38.225 6.751 4.575 11.735 7.944 15.345 10.162 1.816 1.115 3.01 1.768 3.74 2.106 1.264.587.047-.27-2.207-.085a9.04 9.04 0 0 0-6.171 3.255c-1.805 2.175-2.028 4.421-2.05 5.298-.037 1.442.385 2.002-.14.649-.842-2.163-2.755-5.926-6.065-11.981-6.383-11.673-17.084-30.313-30.79-56.427l8.854-4.648 8.855-4.647c13.616 25.943 24.003 44.008 30.63 56.128 3.193 5.841 5.764 10.747 7.156 14.329.591 1.521 1.568 4.223 1.493 7.114-.041 1.602-.43 4.4-2.553 6.958-2.307 2.779-5.345 3.721-7.584 3.905-3.503.287-6.59-1.122-7.844-1.704-1.79-.83-3.763-1.962-5.793-3.209-4.082-2.508-9.501-6.177-16.097-10.647-13.328-9.033-32.389-21.978-58.208-37.699zm44.744-21.987-9.183 3.959c-1.592-3.694-2.57-8.577-.476-13.514 2.074-4.89 6.187-7.524 9.671-8.918 6.54-2.617 15.608-2.79 24.921-2.122 19.416 1.392 47.445 7.163 78.927 15.159 63.244 16.062 142.902 41.755 201.293 62.272l-3.315 9.434-3.315 9.435c-58.114-20.42-137.15-45.899-199.586-61.756-31.358-7.964-57.917-13.34-75.434-14.595-9.152-.656-14.138-.028-16.062.742-.748.3.529.005 1.312-1.84.803-1.894.079-3.03.43-2.214zm301.838 66.27 3.315-9.434c14.446 5.076 23.764 7.557 29.334 8.337 2.893.405 3.866.209 3.742.238-.429.101-3.48 1.145-4.47 4.848-.663 2.479.363 3.815-.2 2.655-.382-.788-1.227-2.13-2.762-4.08-3.038-3.86-7.642-8.684-13.168-14.161-10.554-10.46-24.664-23.407-32.822-33.186-2.107-2.527-4.076-5.136-5.582-7.689-1.363-2.31-3.042-5.704-3.203-9.557-.088-2.124.278-4.63 1.636-7.063 1.374-2.46 3.375-4.154 5.432-5.236 3.697-1.945 7.898-2.108 11.224-1.927l-.544 9.985-.544 9.986c-2.283-.125-2.016.283-.822-.345.804-.423 1.911-1.27 2.717-2.714.791-1.417.916-2.735.884-3.518-.049-1.168-.43-1.258.445.226.733 1.241 1.945 2.918 3.715 5.04 7.353 8.814 19.909 20.263 31.543 31.793 5.568 5.518 10.94 11.087 14.803 15.994 1.915 2.433 3.754 5.067 5.041 7.72 1.107 2.281 2.79 6.523 1.527 11.244-1.59 5.945-6.497 8.569-10.284 9.457-3.482.816-7.368.616-11.08.097-7.638-1.069-18.511-4.116-33.192-9.275zm-8.068-66.27.544-9.985c23.992 1.307 53.294 9.187 89.208 23.096 36.026 13.953 79.346 34.231 131.54 60.831l-4.541 8.91-4.541 8.91c-51.964-26.484-94.587-46.409-129.68-60.001-35.205-13.634-62.2-20.638-83.074-21.775zm216.751 82.852 4.541-8.91c12.541 6.392 20.285 8.082 24.662 7.835 1.972-.11 2.981-.598 3.534-.986.571-.4 1.269-1.127 1.946-2.631 1.516-3.368 2.279-9.178 1.75-17.814-.513-8.372-2.145-18.184-4.33-28.77-4.202-20.36-10.815-44.782-13.332-62.412-1.25-8.752-1.86-17.859.165-25.007 1.072-3.782 3.136-7.934 7.123-10.884 4.12-3.048 8.937-3.818 13.49-3.341l-1.04 9.945-1.04 9.946c-.918-.096-.377.165.485-.472.73-.54.554-.903.225.259-.777 2.74-.835 8.143.391 16.727 2.433 17.042 8.458 38.604 13.121 61.196 2.247 10.889 4.104 21.795 4.704 31.59.584 9.531.084 19.339-3.473 27.243-1.859 4.133-4.649 7.957-8.699 10.798-4.066 2.852-8.809 4.296-13.898 4.582-9.746.548-21.367-3.105-34.866-9.984zm38.509-142.975 1.04-9.946c15.498 1.621 32.26 1.71 59.452 14.612 26.643 12.642 63.22 37.457 120.652 87.501l-6.569 7.54-6.569 7.539c-56.995-49.663-91.935-73.05-116.088-84.51-23.603-11.2-36.915-11.112-52.958-12.79z"
            />
            <path fill="url(#b)" d="M0 .5h237v195H0z" />
            <path
              fill="#fff"
              d="M281.302 65.002c.076 13.294-3.06 24.95-9.812 36.121-7.859 13.086-22.412 26.594-34.092 36.998l-39.068-22.556c3.17-15.317 7.545-34.745 14.995-48.024 6.298-11.433 14.825-19.976 26.376-26.558"
            />
            <path
              stroke="#0A0A0A"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="2.347"
              d="M281.302 65.002c.076 13.294-3.06 24.95-9.812 36.121-7.859 13.086-22.412 26.594-34.092 36.998l-39.068-22.556c3.17-15.317 7.545-34.745 14.995-48.024 6.298-11.433 14.825-19.976 26.376-26.558"
            />
            <path
              fill="#ECF4FF"
              stroke="#0A0A0A"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="2.347"
              d="M198.045 132.634c-1.856.964-3.421 2.399-4.489 4.25-6.975 12.081 3.402 25.607 3.402 25.607s16.902 2.224 23.877-9.857c1.069-1.851 1.511-3.891 1.437-6.012z"
            />
            <path
              fill="#BED9FF"
              stroke="#0A0A0A"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="2.347"
              d="m217.88 126.853-19.583-11.306c-.917 4.363-1.764 8.681-2.615 12.779-.347 1.576.381 3.165 1.759 4.004l25.818 14.906c1.448.793 3.188.628 4.347-.478 3.124-2.787 6.439-5.679 9.76-8.655z"
            />
            <path
              fill="#5F9FFD"
              stroke="#0A0A0A"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="2.347"
              d="M198.297 115.546c2.053-9.856 4.58-21.431 8.12-31.988l-1.539-1.235-5.123 1.373c-25.613 6.863-25.155 40.945-25.629 41.841-.171.897 14.906-3.692 23.415-6.357.257-1.194.5-2.439.756-3.634m65.533 5.144-1.811-6.762c-7.565 8.752-16.757 17.172-24.621 24.193-.995.898-1.97 1.764-2.946 2.629 1.583 8.882 4.449 24.393 5.958 23.056.538-.858 30.242-17.657 23.42-43.116"
            />
            <path
              fill="#ECF4FF"
              stroke="#0A0A0A"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="2.347"
              d="M281.303 65.002c-.564.151-2.249.52-2.832.704-8.339 2.07-16.576.735-23.46-3.24s-12.159-10.44-14.536-18.698c-.151-.563-.674-2.207-.807-2.803 9.532-5.41 20.828-9.15 31.472-11.535a3.57 3.57 0 0 1 2.733.366c.812.468 1.404 1.243 1.683 2.184 3.257 10.41 5.581 22.058 5.747 33.022"
            />
            <path
              fill="#BED9FF"
              stroke="#0A0A0A"
              stroke-width="2.347"
              d="M247.993 74.622c7.223 4.17 9.697 13.407 5.527 20.63s-13.406 9.697-20.629 5.527-9.698-13.406-5.528-20.63c4.17-7.222 13.407-9.698 20.63-5.527Z"
            />
            <path
              fill="#F6C508"
              d="M127.714 53.58c.572-3.456 1.143-10.08 2.286-10.08 1.429 0 2 4.32 2 9.216s3.714 6.336 5.429 6.912c1.714.576 6.571.576 6.571 2.016s-4.286 1.728-7.429 2.304c-3.142.576-3.538 3.143-4 5.472C132 72.3 131.143 79.5 130 79.5s-2.286-5.76-2.286-10.08-2.857-5.76-4.285-6.048C122 63.084 116 63.084 116 61.644s5.143-1.728 7.429-2.016c2.285-.288 3.714-2.592 4.285-6.048"
            />
            <path
              fill="#90BDFF"
              d="M347.878 114.78c.53-2.496 1.061-7.28 2.122-7.28 1.327 0 1.857 3.12 1.857 6.656s3.449 4.576 5.041 4.992 6.102.416 6.102 1.456-3.98 1.248-6.898 1.664-3.285 2.27-3.714 3.952c-.531 2.08-1.327 7.28-2.388 7.28s-2.122-4.16-2.122-7.28-2.654-4.16-3.98-4.368-6.898-.208-6.898-1.248 4.776-1.248 6.898-1.456 3.449-1.872 3.98-4.368"
            />
            <path
              fill="#E9F3FF"
              d="M78.8 125.705c-4.48 0-7.733 5.197-8.8 7.795h48c-.64-6.564-5.6-7.932-8-7.795-1.467-2.735-6.16-8.205-13.2-8.205s-10.4 6.564-11.2 9.846c-.4-.547-2.32-1.641-6.8-1.641M335.8 48.705c-4.48 0-7.733 5.197-8.8 7.795h48c-.64-6.564-5.6-7.932-8-7.795-1.467-2.735-6.16-8.205-13.2-8.205s-10.4 6.564-11.2 9.846c-.4-.547-2.32-1.64-6.8-1.64M278.948 165.756c-5.412 1.273-9.948 7.958-9.948 11.141 14.192.133 44.088.398 50.136.398.796-6.764-7.56-9.151-11.937-7.162 0-5.173-6.366-5.969-9.152-4.377-.796-4.775-5.173-7.162-10.345-7.162s-10.346 3.979-8.754 7.162"
            />
          </g>
          <defs>
            <linearGradient
              id="b"
              x1="237"
              x2="0"
              y1="98"
              y2="98"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#DEECFF" stop-opacity="0" />
              <stop offset="1" stop-color="#DEECFF" stop-opacity=".6" />
            </linearGradient>
            <clipPath id="a">
              <path fill="#fff" d="M0 .5h468v195H0z" />
            </clipPath>
          </defs>
        </svg>
      </header>
      <article className="mx-6 my-8 text-[#0A0A0A]">
        <h1 className="text-center text-[20px] font-[600] leading-[140%] text-[#0A0A0A]">
          {t('版本切换-弹窗-标题')}
        </h1>
        <ul className="mt-3 list-none">
          <li className="flex items-center text-[16px] font-[400] leading-[140%]">
            <div className="h-[4px] w-[4px] rounded-full bg-[#0A0A0A]" />
            <p className="ml-3 w-[calc(100%-12px-4px)] text-[#0A0A0A]">
              {t('版本切换-弹窗-描述1')}
            </p>
          </li>
          <li className="mt-[8px] flex items-center text-[16px] font-[400] leading-[140%]">
            <div className="h-[4px] w-[4px] rounded-full bg-[#0A0A0A]" />
            <p className="ml-3 w-[calc(100%-12px-4px)] text-[#0A0A0A]">
              {t('版本切换-弹窗-描述2')}
            </p>
          </li>
        </ul>
      </article>
      <footer className="mx-6 mb-8 flex justify-between">
        <div
          onClick={handleBackOldVersion}
          className="flex h-[52px] w-[198px] cursor-pointer items-center justify-center rounded-full border-[1.5px] border-solid border-[rgba(0,0,0,0.06)] text-[16px] font-[600] text-[#0A0A0A] hover:bg-black hover:text-white">
          {t('版本切换-弹窗-按钮2')}
        </div>
        <div
          onClick={handleToNewVersion}
          className="flex h-[52px] w-[198px] cursor-pointer items-center justify-center rounded-full bg-[#CD292A] text-[16px] font-[600] text-white hover:bg-[rgba(205,41,42,0.88)]">
          {t('版本切换-弹窗-按钮1')}
        </div>
      </footer>
    </NewModal>
  );
}
